import { useEffect } from 'react';

/**
 * Sets the browser tab title as "VShoppe | <title>".
 * Pass a falsy value to show just "VShoppe".
 */
export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `VShoppe | ${title}` : 'VShoppe';
  }, [title]);
}
